Vue.component('bioscope', {
    props: [],
    data() {
        return {
            targetHeight : null,
        }
    },
    computed: {
        mainStyles() {
            return { paddingTop : this.targetHeight +'px'}
        },
    },
    methods: {
        //
    },
    mounted() {
        this.targetHeight = this.$refs.headerBox.scrollHeight;
    }
});